import { apiClient } from './client';

export type RoutineKind = 'READ_NOTIFY' | 'WRITE_CONFIRM';
export type RoutineRunStatus =
  | 'RUNNING' | 'OK' | 'ERROR' | 'SKIPPED'
  | 'AWAITING_CONFIRMATION' | 'CONFIRMED' | 'CANCELLED' | 'EXPIRED';

export interface RoutineRun {
  tenantId: string;
  runKey: string;
  routineId: string;
  runDate: string;
  status: RoutineRunStatus;
  startedAt: string;
  finishedAt?: string;
  summary?: string;
  errorMessage?: string;
  notifiedCount?: number;
}

export interface RoutineItem {
  id: string;
  title?: { es: string; en: string; zh: string };
  kind: RoutineKind;
  schedule: { hourLocal: number; isoWeekday?: number };
  audience: string[];
  enabled: boolean;
  lastRun: RoutineRun | null;
}

/** GET /api/:tenantId/routines — catálogo con activación y última corrida (routines:read). */
export const fetchRoutines = async (): Promise<RoutineItem[]> =>
  (await apiClient.get('/api/routines')).data.items;

/** GET /api/:tenantId/routines/runs — bitácora reciente (routines:read). */
export const fetchRoutineRuns = async (limit = 50): Promise<RoutineRun[]> =>
  (await apiClient.get('/api/routines/runs', { params: { limit } })).data.items;

/** PATCH /api/:tenantId/routines/:id — activa o desactiva la rutina para la empresa (config:write). */
export const setRoutineEnabled = async (id: string, enabled: boolean): Promise<{ id: string; enabled: boolean }> =>
  (await apiClient.patch(`/api/routines/${encodeURIComponent(id)}`, { enabled })).data;
